import styles from "#batteries-included-components/Banners/ImportDataActionStatus/ImportDataActionStatus.module.scss";
import { useGetOneJob } from "#hooks/adapters/useJobs";
import { useBulkActionToast } from "#src/components/hooks/useBulkActionToast";
import { useStickyState } from "#src/hooks/useStickyState";
import { useClearRecordsCache } from "#src/queries/recordQueries";
import { Banner } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import { useTimeoutHandler } from "./Banners.helpers";

const cx = classNames.bind(styles);

export const ApplyAutomationProgressBanner = ({
  jobStorageKey,
  showCounts,
}: {
  jobStorageKey: string;
  showCounts: boolean;
}) => {
  const { invalidate } = useClearRecordsCache();
  const [jobId, setJobId] = useStickyState<string>("", jobStorageKey);
  const job = useGetOneJob(jobId).data?.data;

  const resetJob = () => {
    invalidate();
    setJobId("");
  };

  useTimeoutHandler(job, "Failed to apply automation due to timeout", resetJob);

  useBulkActionToast({
    job,
    resetJob,
    actionLabel: "Apply automation",
    showCounts,
  });

  return jobId ? (
    <Banner
      className={cx("banner")}
      titleText="Applying Record Automations"
      actionContent={
        <>
          {job?.total_items && showCounts
            ? `Applying ${job.total_items} row(s)`
            : ""}
        </>
      }
      color="loading"
      variant="loading"
    />
  ) : null;
};
